<template>
  <div class="main-character">
    <div>
      <label for="ind-name">{{ $t('nome-do-indicador') + ":" }}</label>
      <b-form-input 
        id="ind-name" 
        maxlength="40"
        v-model="indicatorName" 
        :placeholder="$t('ex-moagem')"
        @change="update">
      </b-form-input>
  
      <label for="ind-unitMensure" class="mt-2">{{ $t('unidade-de-medida') + ":" }}</label>
      <b-form-input 
        id="ind-unitMensure" 
        maxlength="20"
        v-model="unitMensure" 
        :placeholder="$t('ex-ton')"
        @change="update">
      </b-form-input>
  
      <label for="ind-calcType" @mouseenter="setTip(6)" class="mt-2">{{ $t('tipo-do-indicador') + ":" }}<b-icon @mouseenter="setTip(6)" class="icon-button-pentagro tip" icon="patch-question"></b-icon></label>
      <b-form-select 
        id="ind-calcType" 
        v-model="calcType" 
        :options="calcTypes"
        @change="update">
      </b-form-select>
  
      <label v-if="calcType == 'sazonal' || calcType == 'diario'" for="ind-calcDateTime" class="mt-2">{{ $t('horario-do-calculo') + ":" }}<b-icon @mouseenter="setTip(7)" class="icon-button-pentagro tip" icon="patch-question"></b-icon></label>
      <b-form-input 
        id="ind-calcDateTime" 
        v-if="calcType == 'sazonal' || calcType == 'diario'"
        type="time"
        v-model="calcDateTime" 
        @change="update">
      </b-form-input>
      <p class="tip mt-2"> 
        <b-icon class="icon-button-pentagro tip" icon="patch-question"></b-icon>
        {{ $t('passe-o-mouse-sobre-os-pontos-de-interrogacao-para-obter-dicas') }}</p>
    </div>

    <div>
      <label for="kind-view">{{ $t('definir-range-para-calculo-de-aderencia') }}</label>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group id="radio-range" v-model="signal" :aria-describedby="ariaDescribedby"
          name="radio-range">
          <b-form-radio id="less-limit" value="<">
            <span>
              {{ $t('limite-inferior') }}<b-icon @mouseenter="setTip(2)" class="icon-button-pentagro tip" icon="patch-question"></b-icon>
            </span>
          </b-form-radio>
          <b-form-radio id="igual-limit" value="=">
            <span>
              {{ $t('ambos-os-limites') }}<b-icon @mouseenter="setTip(4)" class="icon-button-pentagro tip" icon="patch-question"></b-icon>
            </span>
          </b-form-radio>
          <b-form-radio id="upper-limit" value=">">
            <span>
              {{ $t('limite-superior') }}<b-icon @mouseenter="setTip(3)" class="icon-button-pentagro tip" icon="patch-question"></b-icon>
            </span>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <div class="ind-rule-p">
        <span class="">
          <label for="critical-range">{{ $t('critico') }}<b-icon @mouseenter="setTip(0)" class="icon-button-pentagro tip" icon="patch-question"></b-icon></label>
          <b-form-input id="critical-range" class="range-rule" @keyup="setLimits" v-model="criticalRange" size="sm" type="number" min="0" max="101"></b-form-input>
        </span>
        <b-icon v-if="showRecalc" @click="setLimits" :title="$t('recalcular')" class="icon-button-pentagro recalc" icon="arrow-repeat"></b-icon>
      </div>
      <div class="calculate-range mt-3">
        <label class="mb-0">{{ $t('calculadora-de-range-critico') }} <span>(referência prevista)</span><b-icon @mouseenter="setTip(5)" class="icon-button-pentagro tip" icon="patch-question"></b-icon></label>
        <div class="ind-rule-v" v-if="!isNew">
          <span>
            <label for="inferiorLimit" :title="$t('limite-inferior')">{{ $t('minimo-value') + ":" }}</label>
            <b-input id="inferiorLimit" class="number-range" type="number" size="sm" :disabled="true" v-model="lowCritical"></b-input>
          </span>
          <span>
            <label for="setPoint" :title="$t('ideal-value')" >{{ $t('ideal-value') + ":" }}</label>
            <b-input id="setPoint" class="number-range" type="number" size="sm" v-model="setPoint" :disabled="true"></b-input>
          </span>
          <span>
            <label for="upperLimit" :title="$t('limite-superior')" >{{ $t('maximo-value') + ":"}}</label>
            <b-input id="upperLimit" class="number-range" type="number" size="sm" :disabled="true" v-model="upperCritical"></b-input>
          </span>
        </div>
        <p v-else id="prev-ref-notfound">Configure o valor ideal pelo passo 3 (Referência Prevista) e finalize as alterações.</p>
      </div> 
      <div class="descriptions mt-3">
        <b-card v-if="tip==0" class="character-info" border-variant="secondary" :header="$t('percentual-critico')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('utilizado-para-calculo-de-aderencia-se-o-valor-real-estiver-dentro-dos-limites') }} <strong>{{ $t('criticos') }}</strong> {{ $t('o-indicador-esta-aderente-naquele-momento') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==2" class="character-info" border-variant="secondary" :header="$t('limite-inferior')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('indicador-estara-aderente-sempre-quando-o-valor-real-estiver') }} <strong>{{ $t('acima-0') }}</strong> {{ $t('deste-limite-para-gatilho-o-mesmo-se-aplica') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==3" class="character-info" border-variant="secondary" :header="$t('limite-superior')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('indicador-estara-aderente-sempre-quando-o-valor-real-estiver') }} <strong>{{ $t('abaixo-0') }}</strong> {{ $t('deste-limite-para-gatilho-o-mesmo-se-aplica') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==4" class="character-info" border-variant="secondary" :header="$t('ambos-os-limites')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('o-valor-real-do-indicador-precisa-estar-entre-os-ranges-operacionais-para-estar-aderente-os-gatilhos-serao-analizados-dentro-dos-ranges-criticos') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==5" class="character-info" border-variant="secondary" :header="$t('calculadora-de-range')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('simule-aqui-os-ranges-ideais') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==6 && calcType == 'online'" class="character-info" border-variant="secondary" :header="$t('indicador-online')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('este-indicador-e-calculado-em-um-tempo-curto-pois-seus-valores-reais-sao-gerados-atraves-da-automacao-muito-utilizado-em-tela-de-monitoramento') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==6 && calcType == 'analitico'" class="character-info" border-variant="secondary" :header="$t('indicador-analitico')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('este-indicador-e-calculado-sempre-que-uma-nova-analise-laboratorial-e-lancada-os-valores-reais-geralmente-vem-de-uma-base-de-dados') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==6 && calcType == 'diario'" class="character-info" border-variant="secondary" :header="$t('indicador-diario')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('este-indicador-e-calculado-uma-vez-ao-dia-configurando-seu-horario-geralmente-utilizado-para-dados-consolidado-lineares') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==6 && calcType == 'sazonal'" class="character-info" border-variant="secondary" :header="$t('indicador-sazonal')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('indicador-calculado-uma-vez-ao-dia-configurando-seu-horario-geralmente-utilizado-para-dados-consolidado-nao-linear-considerando-sazonalidades-como-paradas-programadas-sua-sazonaldiade-pode-ser-configurada-no-calendario-sazonal') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==7" class="character-info" border-variant="secondary" :header="$t('hora-do-calculo')" header-border-variant="secondary" align="center">
          <b-card-text>{{ $t('defina-a-partir-de-qual-horario-o-sistema-podera-calcular-esse-indicador') }}</b-card-text>
        </b-card>
        <b-card v-if="tip==8" class="character-info" border-variant="warning" :header="$t('range-critico-inferior-ao-operacional')" header-border-variant="warning" align="center">
          <b-card-text>{{ $t('o-sistema-ira-atribuir-automaticamente-o-valor-operacional-ao-critico') }}</b-card-text>
        </b-card>
      </div>
      <div class="button-rigth" v-if="canNext">
        <b-icon id="next-step" class="icon-button-pentagro mr-2 mt-1" :title="$t('proximo')" icon="arrow-right" @click="next"></b-icon>
      </div>
    </div>
    
  </div>
</template>

<script>
import { SimpleNumberFormat } from '../../../../../global'
import Mediator from '../../utilities/Mediator'
export default {
  name: "Manage-Character",
  data() {
    return {
      step: "step-1",
      nextStep: "step-2",
      isNew:true,
      indicatorName: "",
      unitMensure: "",
      inferiorLimit: "96",
      setPoint: "",
      upperLimit: "104",
      calcType: "online",
      calcDateTime: "06:00",
      autoComplete: false,
      calcTypes: [
        { value: "online", text: this.$t('online') },
        { value: "analitico", text: this.$t('analitico') },
        { value: "sazonal", text: this.$t('sazonal') },
        { value: "diario", text: this.$t('diario') },
      ],
      signal: "=",
      kindOfView: "v",
      criticalRange: 5,
      operatingRange: 4,
      lowCritical: 0, 
      upperCritical: 0,
      tip: 0,
      message: "",
      showRecalc: false,
      canNext: false
    }
  },

  watch:{
    signal(){
      this.setLimits()
    },

    setPoint(){
      this.setLimits()
    },

    criticalRange(val){
      this.criticalRange = val
      this.setLimits()
    }
  },

  methods: {
    setTip(value){
      this.tip = value
    },

    adjustTag(value){
      return value.replace(/\//g, "-")
                   .replace(/[^a-z0-9/-_]/gi, "")
                   .replace(/(^[0-9])/, "_$1");
    },

    autoCompleteSetPoint() {
      if(this.inferiorLimit && this.upperLimit){
        this.autoComplete = true;
        let { inferior, upper } = this.getRange();

        this.setPoint = (inferior + ((upper - inferior) / 2)).toString()
        this.updateRange()
      }
      else
        this.autoComplete = false;
    },

    sendMessage(message){
      this.message = message;
      setTimeout(() => {
        this.message = "";
      }, 6000);
    },

    checkLimits(){
      setTimeout(() => {
        if(this.criticalRange < this.operatingRange && !this.message){
          this.sendMessage(this.$t('atencao-range-critico-precisa-ser-maior-que-o-range-de-operacao'))
          this.checkLimits();
        }
        else if(this.criticalRange < this.operatingRange){
          setTimeout(this.checkLimits, 5300)
        }
      }, 1000);
    },

    setLimits(){
      this.checkLimits()
      if(this.signal == ">"){
        this.lowCritical = ""
        this.upperCritical = (this.setPoint * (1 + (this.criticalRange / 100))).toFixed(4)
      }
      else if(this.signal == "<"){
        this.upperCritical = ""
        this.lowCritical = (this.setPoint * (1 - (this.criticalRange / 100))).toFixed(4)
      }
      else{
        this.upperCritical = (this.setPoint * (1 + (this.criticalRange / 100))).toFixed(4)
        this.lowCritical = (this.setPoint * (1 - (this.criticalRange / 100))).toFixed(4)
      }
      this.showRecalc = false;
      
      this.updateRange()
    },

    getRange(){
      let num1 = 0;
      let num2 = 0;
      if(this.signal == "<"){
        num1= SimpleNumberFormat(this.lowCritical).toFixed(4);
        num2 = SimpleNumberFormat(this.setPoint).toFixed(4)
      }
      else if(this.signal == ">"){
        num1= SimpleNumberFormat(this.upperCritical).toFixed(4);
        num2 = SimpleNumberFormat(this.setPoint).toFixed(4)
      }
      else{
        num1= SimpleNumberFormat(this.upperCritical).toFixed(4);
        num2= SimpleNumberFormat(this.lowCritical).toFixed(4);
      }

      let inferior = Math.min(num1, num2)
      let upper = Math.max(num1, num2)

      return { inferior, upper }
    },

    // calcPercentage(){
    //   let { inferior, upper } = this.getRange();
    //   let critical = isNaN(this.criticalRange) ? this.operatingRange : this.criticalRange;
    //   let dif = parseFloat(critical - this.operatingRange)
    //   let difLow = this.setPoint - inferior
    //   let difMax = upper - this.setPoint
    //   let difMiddle = difLow > 0 && difMax > 0 ? (difLow + difMax) / 2 : difLow > 0 ? difLow : difMax;
    //   let setPointIsAValidNumber = parseFloat(this.setPoint) == 0 || isNaN(parseFloat(this.setPoint));

    //   this.criticalRange = !setPointIsAValidNumber ? ((1 - parseFloat(this.setPoint - difMiddle) / parseFloat(this.setPoint)) * 100).toFixed(4) : this.operatingRange;
    //   this.operatingRange = parseFloat(this.criticalRange) - dif
    //   this.showRecalc = true
    //   this.updateRange()
    // },

    updateRange(){
      if(!this.criticalRange && this.criticalRange != 0){
        this.criticalRange = this.operatingRange;
      }
      
      let critic = this.criticalRange;
      // if(this.criticalRange < this.operatingRange) {
      //   critic = this.operatingRange
      // }

      let indicatorRule = `${this.signal} ${this.operatingRange} ${critic}`
      Mediator.notify({ setPoint: this.setPoint, indicatorRule, critic }, "update-indicatorRule")
    },

    next(){
      Mediator.notify(this, "update-indicator")
      Mediator.notify(this, "select-step-by-form")
    },

    clearForm(){
      this.indicatorName = "";
      this.unitMensure = "";
      this.calcType = "online";
      this.calcDateTime = "06:00";
      this.canNext = false;
    },

    update(){
      Mediator.notify(this, "update-indicator")
    },

    updateInd(value){
      this.indicatorName = value.indicatorName;
      this.unitMensure = value.unitMensure;
      this.calcType = value.calcType;
      this.calcDateTime = value.calcDateTime;
      this.setPoint = value.setPoint;
      this.inferiorLimit = value.inferiorLimit;
      this.upperLimit = value.upperLimit;
      this.operatingRange = value.operatingRange;
      this.criticalRange = value.criticalRange;
      this.canNext = true;
      this.signal = value.signal;

      if(this.setPoint == ""){
        this.isNew = true
      }
    }
  },

  mounted() {
    Mediator.notify(this, "init-step")
  },

  beforeUpdate(){
    let ind = localStorage.getItem("indicator")
    if(ind != undefined && ind != null && this.setPoint != ""){
      this.isNew = ind.isNew
    }else{
      this.isNew = true
    }
  }
}
</script>

<style scoped>

h5{
  text-align: center;
}

#prev-ref-notfound{
  padding: .5rem 0;
  color: #ee730e;
}

.show-error,
.tip{
  font-size: 0.6rem;
  cursor: help;
}

.show-error{
  font-size: 0.8rem;
  color: #a00;
}

.recalc{
  align-self: end;
  margin-left: 8px;
}


.main-character{
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 8px;
  justify-self: center;
  flex-direction: column;
  justify-items: center;
  width: 100%;
}

.descriptions{
  height: 24.4vh;
  display: flex;
  align-content: center;
}

.character-info{
  margin: auto;
  width: 85%;
  align-self: center;
}

.main-character>div{
  width: 100%;
}

.main-character>div:last-child{
  border-left: 1px solid #0003;
  padding-left: 8px;
}

.main-character>div>div>span>label,
.main-character>div>label,
.main-character>div>div>label{
  font-weight: 600;
}

.calculate-range{
  background-color: #00000005;
  box-shadow: 0 0 3px #00000018;
  border-radius: 4px;
  padding: 0 4px;
}

.button-pentagro{
  background-color: #00A39F;
  border-color: #00A39F;
}

.button-rigth{
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

#next-step{
  justify-self: flex-end;
}

.kind-view,
.ind-rule-p,
.ind-rule-v{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}

.ind-rule-v>span:first-child,
.ind-rule-v>span:last-child{
  min-width: 140px;
}

.ind-rule-p{
  justify-content: flex-start;
}


.range-rule{
  width: 150px;
}

.number-range{
  width: 75%;
}

@media (min-height: 770px) {
  .descriptions{
    height: 43.3vh;
  }
}

</style>